import { Button } from "@/components/ui/button";
import { Download } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { usePWAInstall } from "@/hooks/usePWAInstall";
import { useToast } from "@/hooks/use-toast";

interface InstallButtonProps {
  variant?: "default" | "ghost" | "outline";
  showLabel?: boolean;
  size?: "sm" | "default" | "lg" | "icon";
}

export const InstallButton = ({ 
  variant = "default", 
  showLabel = true,
  size = "sm" 
}: InstallButtonProps) => {
  const navigate = useNavigate();
  const { toast } = useToast();
  const { isInstallable, canShowButton, promptInstall } = usePWAInstall();

  // Ne pas afficher si déjà installé
  if (!canShowButton) return null;

  const handleClick = async () => {
    if (isInstallable) {
      // Chrome/Edge : installation directe via API native
      const success = await promptInstall();
      if (success) {
        toast({
          title: "Application installée !",
          description: "MiamSécur a été ajouté à votre écran d'accueil",
        });
      }
    } else {
      // Safari/Firefox/autres : page d'instructions
      navigate('/install');
    }
  };

  return (
    <Button 
      variant={variant}
      size={size}
      onClick={handleClick}
      aria-label="Installer l'application"
    >
      <Download className="h-4 w-4" />
      {showLabel && <span className="ml-1 text-xs">Installer</span>}
    </Button>
  );
};
